import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledCard,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
} from './components/CardStyles';
import { formatCardTitle } from './utils/cardHelpers';

const Card = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>;
};

const Header = ({ title, children, ...props }) => (
  <CardHeader {...props}>
    <CardTitle>{formatCardTitle(title)}</CardTitle>
    {children}
  </CardHeader>
);

const Body = ({ children, ...props }) => (
  <CardBody {...props}>{children}</CardBody>
);

const Footer = ({ children, ...props }) => (
  <CardFooter {...props}>{children}</CardFooter>
);

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

Header.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node,
};

Body.propTypes = {
  children: PropTypes.node.isRequired,
};

Footer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Card;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Card/Card.jsx